"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mLga = exports.mState = exports.mCountry = void 0;
var classes_1 = require("./classes");
var locs_1 = require("./locs");
var mCountry = /** @class */ (function () {
    function mCountry() {
    }
    /**
   * Retrieves an array of all countries (Only supports Nigeria for now).
   * Set oderedList to true if you want the data ordered
   *
   * @returns {mLoc[]} An array of mLoc objects representing countries.
   */
    mCountry.getAllCountries = function (oderedList) {
        var countries = [];
        for (var countryCode in locs_1.locs) {
            if (locs_1.locs.hasOwnProperty(countryCode)) {
                var acountry = locs_1.locs[countryCode];
                var country = {
                    name: acountry.name,
                    center: acountry.center
                };
                countries.push(new classes_1.mLoc(countryCode, country));
            }
        }
        if (oderedList) {
            return countries.slice().sort(function (a, b) { return a.getName().localeCompare(b.getName()); });
        }
        return countries;
    };
    /**
   * Retrieves a country by its code
   *
   * @returns {mLoc}
   */
    mCountry.getCountryByCode = function (countryCode) {
        if (locs_1.locs[countryCode]) {
            var acountry = locs_1.locs[countryCode];
            var country = {
                name: acountry.name,
                center: acountry.center
            };
            return new classes_1.mLoc(countryCode, country);
        }
        return undefined;
    };
    return mCountry;
}());
exports.mCountry = mCountry;
var mState = /** @class */ (function () {
    function mState() {
    }
    /**
   * Retrieves an array of all states in the provided country code.
   * Set oderedList to true if you want the data ordered
   *
   * @returns {mLoc[]} An array of mLoc objects representing states.
   */
    mState.getStatesByCountry = function (countryCode, oderedList) {
        var states = [];
        if (locs_1.locs[countryCode]) {
            var nLoc = locs_1.locs[countryCode]['states'];
            for (var stateCode in nLoc) {
                if (nLoc.hasOwnProperty(stateCode)) {
                    var astate = nLoc[stateCode];
                    var state = {
                        name: astate.name,
                        center: astate.center
                    };
                    states.push(new classes_1.mLoc(stateCode, state));
                }
            }
        }
        if (oderedList) {
            return states.slice().sort(function (a, b) { return a.getName().localeCompare(b.getName()); });
        }
        return states;
    };
    /**
   * Retrieves a state by its code and countryCode
   *
   * @returns {mLoc}
   */
    mState.getStateByCode = function (countryCode, stateCode) {
        if (locs_1.locs[countryCode]) {
            var nLoc = locs_1.locs[countryCode]['states'];
            if (nLoc && nLoc[stateCode]) {
                var astate = nLoc[stateCode];
                var state = {
                    name: astate.name,
                    center: astate.center
                };
                return new classes_1.mLoc(stateCode, state);
            }
        }
        return undefined;
    };
    return mState;
}());
exports.mState = mState;
var mLga = /** @class */ (function () {
    function mLga() {
    }
    /**
   * Retrieves an array of all LGAs in the specified country & state.
   * Set oderedList to true if you want the data ordered
   *
   * @returns {mLoc[]} An array of mLoc objects representing LGAs.
   */
    mLga.getLgasByState = function (countryCode, stateCode, oderedList) {
        var lgas = [];
        if (locs_1.locs[countryCode]) {
            var nLoc = locs_1.locs[countryCode]['states'];
            if (nLoc && nLoc[stateCode]) {
                var nnLoc = nLoc[stateCode]['lgas'];
                for (var lgaCode in nnLoc) {
                    if (nnLoc.hasOwnProperty(lgaCode)) {
                        var lga = nnLoc[lgaCode];
                        lgas.push(new classes_1.mLoc(lgaCode, lga));
                    }
                }
            }
        }
        if (oderedList) {
            return lgas.slice().sort(function (a, b) { return a.getName().localeCompare(b.getName()); });
        }
        return lgas;
    };
    /**
   * Retrieves an LGA by its code, state code and country code
   *
   * @returns {mLoc}
   */
    mLga.getLgaByCode = function (countryCode, stateCode, lgaCode) {
        if (locs_1.locs[countryCode]) {
            var nLoc = locs_1.locs[countryCode]['states'];
            if (nLoc && nLoc[stateCode]) {
                var nnLoc = nLoc[stateCode]['lgas'];
                if (nnLoc && nnLoc[lgaCode]) {
                    var lga = nnLoc[lgaCode];
                    return new classes_1.mLoc(lgaCode, lga);
                }
            }
        }
        return undefined;
    };
    return mLga;
}());
exports.mLga = mLga;
